import { render, staticRenderFns } from "./ChoosePostType.vue?vue&type=template&id=d23a0cdc&scoped=true&"
import script from "./ChoosePostType.vue?vue&type=script&lang=ts&"
export * from "./ChoosePostType.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePostType.vue?vue&type=style&index=0&id=d23a0cdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23a0cdc",
  null
  
)

export default component.exports